const getLocalStorage = () => {
    try {
        return window.localStorage;
    } catch (error) {
        console.warn('localStorage access failed:', error);
        return null;
    }
};

const safeLocalStorageGet = key => {
    try {
        const storage = getLocalStorage();
        return storage ? storage.getItem(key) : null;
    } catch (error) {
        console.warn(`localStorage.getItem failed for key "${key}":`, error);
        return null;
    }
};

const safeLocalStorageSet = (key, value) => {
    try {
        const storage = getLocalStorage();
        if (!storage) return false;
        storage.setItem(key, value);
        return true;
    } catch (error) {
        console.warn(`localStorage.setItem failed for key "${key}":`, error);
        return false;
    }
};

const safeLocalStorageRemove = key => {
    try {
        const storage = getLocalStorage();
        if (!storage) return false;
        storage.removeItem(key);
        return true;
    } catch (error) {
        console.warn(`localStorage.removeItem failed for key "${key}":`, error);
        return false;
    }
};

export {
    safeLocalStorageGet,
    safeLocalStorageRemove,
    safeLocalStorageSet
};
